<script>
import MixedGridImageItem from '@phoenix/mixins/components/mixedGrid/MixedGridImageItem';

export default {
  mixins: [MixedGridImageItem],
  props: {
    hoverImage: {
      type: Object,
      default: null,
    },
  },
};
</script>

<template>
  <component :is="page.url ? 'a' : 'div'" class="image-fit" :href="page.url || null">
    <div class="product-cards__poster">
      <div class="picture picture--cover">
        <picture-lazy v-bind="image" img-class="lazyload lazyload--fade lazyload--fade product-card-media__image" />
        <picture-lazy
          v-if="hoverImage"
          v-bind="hoverImage"
          img-class="lazyload lazyload--fade product-card-media__image-hover"
        />
      </div>
    </div>
  </component>
</template>
